<div class="card h-100">
  <div class="card-header border-0 bg-transparent p-3">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h5 class="card-title mb-1">Critical & High Severity MTTM Analysis</h5>
        <p class="text-muted small mb-0">
          Mean Time To Mitigate for Critical (9.0-10.0) and High (7.0-8.9) vulnerabilities
        </p>
      </div>
      <div class="d-flex align-items-center gap-2">
        <button
          kendoButton
          [themeColor]="'light'"
          [size]="'small'"
          [svgIcon]="pencilIcon"
          (click)="onSLAEdit.emit({ type: 'both' })"
          class="d-flex align-items-center gap-2"
        >
          <span>Configure SLA Targets</span>
        </button>
        <kendo-dropdownbutton
          [svgIcon]="moreVerticalIcon"
          fillMode="flat"
          size="small"
          [data]="[{ text: 'View Data' }]"
          (itemClick)="onViewData()"
        ></kendo-dropdownbutton>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="row mb-4">
      <div class="col-md-6">
        <div class="card border-0 left-border-danger bg-opacity-10">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h6 class="text-danger mb-0">Critical Vulnerabilities (9.0-10.0)</h6>
              <span class="badge bg-danger bg-opacity-75 px-2">
                SLA: {{slaTargetsResponse().critical}} days
              </span>
            </div>
            <div class="d-flex align-items-baseline">
              <h2 class="mb-0 me-2">{{mttmAnalysisResponse().current_critical_average_mttm}}</h2>
              <span class="text-muted">days average</span>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-3">
              <div>
                <small class="text-success d-block">
                  <i class="fas fa-arrow-down me-1"></i>
                  {{mttmAnalysisResponse().critical_average_mttm_difference}} days vs last month
                </small>
                <small class="text-muted">Previous: {{mttmAnalysisResponse().previous_critical_average_mttm}} days</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card border-0 left-border-warning bg-opacity-10">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h6 class="text-warning mb-0">High Vulnerabilities (7.0-8.9)</h6>
              <span class="badge bg-warning bg-opacity-75 px-2">
                SLA: {{slaTargetsResponse().high}} days
              </span>
            </div>
            <div class="d-flex align-items-baseline">
              <h2 class="mb-0 me-2">{{mttmAnalysisResponse().current_high_average_mttm}}</h2>
              <span class="text-muted">days average</span>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-3">
              <div>
                <small class="text-success d-block">
                  <i class="fas fa-arrow-down me-1"></i>
                  {{mttmAnalysisResponse().high_average_mttm_difference}} days vs last month
                </small>
                <small class="text-muted">Previous: {{mttmAnalysisResponse().previous_high_average_mttm}} days</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <kendo-chart [style.height.px]="300">
          <kendo-chart-title text="Critical & High MTTM Trend"></kendo-chart-title>
          <kendo-chart-series>
            <kendo-chart-series-item
              type="column"
              [stack]="true"
              [data]="chartData()"
              field="critical"
              categoryField="date"
              name="Critical (9.0-10.0)"
              [border]="{ width: 0 }"
              [gap]="0.3"
              [spacing]="0.1"
            >
              <kendo-chart-series-item-labels
                position="center"
                format="{0} days"
                [visible]="true"
              ></kendo-chart-series-item-labels>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              type="column"
              [stack]="true"
              [data]="chartData()"
              field="high"
              categoryField="date"
              name="High (7.0-8.9)"
              [opacity]="0.9"
              [border]="{ width: 0 }"
              [gap]="0.3"
              [spacing]="0.1"
            >
              <kendo-chart-series-item-labels
                position="center"
                format="{0} days"
                [visible]="true"
              ></kendo-chart-series-item-labels>
            </kendo-chart-series-item>
          </kendo-chart-series>
          <kendo-chart-category-axis>
            <kendo-chart-category-axis-item [weekStartDay]="1">
              <kendo-chart-category-axis-item-labels format="{0:MMM d}"></kendo-chart-category-axis-item-labels>
            </kendo-chart-category-axis-item>
          </kendo-chart-category-axis>
          <kendo-chart-value-axis>
            <kendo-chart-value-axis-item>
              <kendo-chart-value-axis-item-labels format="{0} days"></kendo-chart-value-axis-item-labels>
              <kendo-chart-value-axis-item-title
                text="Mean Time To Remediate (Days)"
              ></kendo-chart-value-axis-item-title>
            </kendo-chart-value-axis-item>
          </kendo-chart-value-axis>
          <kendo-chart-tooltip format="{0} days"></kendo-chart-tooltip>
          <kendo-chart-legend position="bottom"></kendo-chart-legend>
        </kendo-chart>
      </div>
    </div>
  </div>
</div>

@if (showPopup()) {
  <kendo-dialog
    (close)="close()"
    [width]="'95vw'"
    [height]="'90vh'"
    [minWidth]="'800px'"
    [maxWidth]="'1400px'"
  >
    <kendo-dialog-titlebar>{{ modalTitle() }}</kendo-dialog-titlebar>

    @if (datatableUrl(); as url) {
      <div class="table-responsive w-100">
        <app-datatable
          [data-href]="url"
          [columns]="datatableColumns"
          [useOData]="true"
          [initialFilters]="periodParams()"
        ></app-datatable>
      </div>
    }
  </kendo-dialog>
}
